import { ComponentPropsWithoutRef, forwardRef } from 'react';

import { IconButton, Tooltip } from '@mui/material';

import FontAwesomeIcon from './FontAwesomeIcon';
import { classNames } from './utils';

import styles from './uiHelpers.module.css';

type PlayButtonProps = {
  playing: boolean;
  setPlaying: (val: boolean) => void;
  disabled: boolean;
} & Omit<ComponentPropsWithoutRef<typeof IconButton>, 'onClick' | 'disabled'>;

export const PlayButton = forwardRef<HTMLButtonElement, PlayButtonProps>(
  function PlayButton({ playing, setPlaying, disabled, ...other }, ref) {
    return (
      <Tooltip title={playing ? 'Pause' : 'Play'}>
        <IconButton
          ref={ref}
          size="small"
          onClick={() => setPlaying(!playing)}
          disabled={disabled}
          color={playing ? 'warning' : undefined}
          {...other}
          className={classNames(
            styles.btn,
            playing ? styles.pauseButton : styles.playButton,
          )}
        >
          <FontAwesomeIcon name={!playing ? 'circle-play' : 'circle-pause'} />
        </IconButton>
      </Tooltip>
    );
  },
);

type ArrowButtonProps = {
  disabled: boolean;
  handleClick: () => void;
  forward?: boolean;
} & Omit<ComponentPropsWithoutRef<typeof IconButton>, 'onClick'>;

export const ArrowButton = forwardRef<HTMLButtonElement, ArrowButtonProps>(
  function ArrowButton(
    { disabled, handleClick, forward = true, ...other },
    ref,
  ) {
    return (
      <IconButton
        ref={ref}
        size="small"
        onClick={handleClick}
        disabled={disabled}
        {...other}
        className={classNames(styles.btn, styles.dayChangeButton)}
      >
        <FontAwesomeIcon name={forward ? 'caret-right' : 'caret-left'} />
      </IconButton>
    );
  },
);
